export default "__VITE_ASSET__b95f45a8__"